// extracted by mini-css-extract-plugin
export default {"navbarTitle":"App_navbarTitle__UDrHP","navbarList":"App_navbarList__DTdLu","navbarIcons":"App_navbarIcons__y0s-N","logoutButton":"App_logoutButton__VDsrA"};